module.exports = __webpack_public_path__ + "img/ep-Y-dosis.5469281f.jpg";